import { Container, Grid, Text, Link } from "basis";
import { CreditCard } from "../CreditCard/CreditCard";
import { SvgInline } from "../SvgInline/SvgInline";

function CloseAccountInProgress({ state }) {
  const { accountInfo } = state;

  return (
    <Grid rowsGap="8">
      <Container bg="grey.t05" padding="4">
        <CreditCard
          cardName={accountInfo.cardName}
          cardEndsWith={accountInfo.cardEndsWith}
        />
      </Container>
      <SvgInline name="break" size="92" />
      <Text as="h3" textStyle="heading5" textStyle-sm="heading4">
        Your close account request is currently in progress
      </Text>
      <Text>
        We'll send you an email to notify you when your request has been
        processed.
        <br />
        You can also check back here to see the status of your request.
      </Text>
      <Container>
        <Link appearance="primary-button" href="/" newTab={false}>
          Go to overview
        </Link>
      </Container>
    </Grid>
  );
}

export { CloseAccountInProgress };
